import { render, staticRenderFns } from "./DebugPanel.vue?vue&type=template&id=31767756&scoped=true"
import script from "./DebugPanel.vue?vue&type=script&lang=js"
export * from "./DebugPanel.vue?vue&type=script&lang=js"
import style0 from "./DebugPanel.vue?vue&type=style&index=0&id=31767756&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31767756",
  null
  
)

export default component.exports